

<form [formGroup]='movingTo'
      (ngSubmit)='onSubmit()'
      id='{{formGroupName}}'>

	<div class='step-title' *ngIf='!movingTo.controls["_extendedOptional"].value' i18n>Where are you moving <span class='color-blue'>to</span>?</div>
	<div class='step-title' *ngIf='movingTo.controls["_extendedOptional"].value' i18n>Where exactly are you moving <span class='color-blue'>to</span>?</div>

	<div class='fields-group'>
		<div class='form-control form-control-full'>
			<mat-form-field>
				<mat-label i18n='@@labelCountry'>Country</mat-label>
				<select matNativeControl
				        (change)='onCountryChange()'
				        autocomplete='a92b'
				        [tabIndex]='formService.verifyTabIndex( formGroupName )'
				        [attr.disabled]='this.enableFields ? null : "disabled"'
				        formControlName='country'>
					<option *ngIf="!movingTo.controls['country'].value" [ngValue]="null" selected i18n='@@selectPlaceholder'>&nbsp;- Select -</option>
					<optgroup *ngIf='formService.popularCountries && formService.popularCountries.length' i18n-label='@@labelPopularCountries' label='&nbsp;Popular'>
						<option *ngFor='let country of formService.popularCountries'
						        [value]='country.country_code'>
							<ng-container *ngIf='movingTo.controls["country"].value != country.country_code'>&nbsp;</ng-container>{{country.country}}
						</option>
					</optgroup>
					<optgroup i18n-label='@@labelAllCountries' label='&nbsp;All countries'>
						<option *ngFor='let country of formService.countries'
						        [value]='country.country_code'>
							<ng-container *ngIf='movingTo.controls["country"].value != country.country_code'>&nbsp;</ng-container>{{country.country}}
						</option>
					</optgroup>
				</select>
			</mat-form-field>
		</div>

		<ng-container *ngFor='let fieldType of fieldOrder'>
			<div *ngIf='fieldType == "address"' class='form-control form-control-full'>
				<mat-form-field>
					<mat-label>{{labelAddress}} <ng-container *ngIf='movingTo.controls["_extendedOptional"].value' i18n='@@optional'>(optional)</ng-container></mat-label>
					<input formControlName='address'
					       (input)="formService.markAddressInput( 'movingTo' )"
					       name='address'
					       placeholder=''
					       type='text'
					       autocomplete='a3ab1'
					       #addressInputEl
					       [attr.disabled]='this.enableFields ? null : "disabled"'
					       [tabIndex]='formService.verifyTabIndex( formGroupName )'
					       [matAutocomplete]="auto"
					       matInput>
					<mat-autocomplete #auto="matAutocomplete" 
					                  (optionSelected)="onSelectSuggestion($event.option.value)"
					                  [displayWith]="displayWithTyped">
						<mat-option *ngFor="let suggestion of autocompleteSuggestions$ | async" [value]="suggestion">
							{{ suggestion.placePrediction?.text || suggestion.text }}
						</mat-option>
					</mat-autocomplete>
				</mat-form-field>
			</div>
			<div *ngIf='fieldType == "postcode" && postcodeEnabled' class='form-control form-control-small'>
				<mat-form-field>
					<mat-label>{{labelPostcode}} <ng-container *ngIf='movingTo.controls["_extendedOptional"].value' i18n='@@optional'>(optional)</ng-container></mat-label>
					<input matInput
					       formControlName='postcode'
       (input)="formService.markAddressInput( 'movingTo' )"
					       placeholder=''
					       type='text'
					       autocomplete='a5ab1'
					       [attr.disabled]='this.enableFields ? null : "disabled"'
					       [tabIndex]='formService.verifyTabIndex( formGroupName )'
					       name='postcode'/>
				</mat-form-field>
			</div>
			<div *ngIf='fieldType == "city"' class='form-control form-control-wide' [class]='!postcodeEnabled ? "form-control-full" : ""'>
				<mat-form-field>
					<mat-label i18n='@@labelCity'>City</mat-label>
					<input matInput
					       formControlName='city'
       (input)="formService.markAddressInput( 'movingTo' )"
					       name='city_to'
					       type='text'
					       autocomplete='a5ab2'
					       [attr.disabled]='this.enableFields ? null : "disabled"'
					       [tabIndex]='formService.verifyTabIndex( formGroupName )'
					       placeholder=''/>
				</mat-form-field>
			</div>
		</ng-container>

		<div *ngIf='isStateFieldEnabled()' class='form-control form-control-full'>
			<mat-form-field>
				<mat-label i18n='@@labelState'>State</mat-label>
				<select matNativeControl
				        formControlName='state'
				        [tabIndex]='formService.verifyTabIndex( formGroupName )'
				        [attr.disabled]='this.enableFields ? null : "disabled"'
				        [attr.required]='isStateFieldEnabled()'
				        name='state'>
					<optgroup label="States">
						<option *ngFor='let state of states'
					        [value]='state.code'>
						{{state.name}}
						</option>
					</optgroup>
				</select>
			</mat-form-field>
		</div>
	</div>

	<div class='step-footer step-footer-center'>
		<div class='step-footer-buttons'>
			<button class='back' type='button' (click)='formService.backMainForm()'><mat-icon svgIcon='icons:chevron-left'></mat-icon><ng-container i18n='@@buttonBack'>Back</ng-container></button>
			<button class='submit' type='submit'><ng-container i18n='@@buttonContinue'>Continue</ng-container><mat-icon svgIcon='icons:chevron-right'></mat-icon></button>
		</div>
	</div>
</form>

